import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  RiAddLine,
  RiEdit2Line,
  RiDeleteBin6Line,
  RiSearchLine,
  RiArrowLeftSLine,
  RiArrowRightSLine,
} from "react-icons/ri";

import { getWoodTypes, deleteWoodType } from "../services/woodTypeService";
import "./UnitList.css";

const WoodTypeListLayer = () => {
  const [woodTypes, setWoodTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    loadWoodTypes();
  }, []);

  const loadWoodTypes = async () => {
    try {
      const res = await getWoodTypes();
      if (res.status === "success") {
        setWoodTypes(res.data || []);
      } else toast.error(res.message);
    } catch {
      toast.error("API Error");
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this wood type?")) return;

    try {
      const res = await deleteWoodType(id);
      if (res.status === "success") {
        toast.success("Wood type deleted");
        loadWoodTypes();
      } else toast.error(res.message);
    } catch {
      toast.error("API Error");
    }
  };

  const filteredData = useMemo(() => {
    return woodTypes.filter((w) =>
      w.wood_type.toLowerCase().includes(search.toLowerCase())
    );
  }, [woodTypes, search]);

  const effectivePageSize =
    pageSize === "all" ? filteredData.length : pageSize;

  const totalPages =
    effectivePageSize === 0
      ? 1
      : Math.ceil(filteredData.length / effectivePageSize);

  const paginatedData =
    pageSize === "all"
      ? filteredData
      : filteredData.slice(
          (currentPage - 1) * effectivePageSize,
          currentPage * effectivePageSize
        );

  return (
    <div className="ul-page">
      <div className="ul-header">
        <h4>Wood Type List</h4>
        <Link to="/add-wood-type" className="ul-add-btn">
          <RiAddLine /> Add Wood Type
        </Link>
      </div>

      <div className="ul-filters">
        <div className="ul-search">
          <RiSearchLine />
          <input
            placeholder="Search wood type..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="ul-pagesize">
          <span>Show</span>
          <select
            value={pageSize}
            onChange={(e) => {
              setPageSize(
                e.target.value === "all"
                  ? "all"
                  : Number(e.target.value)
              );
              setCurrentPage(1);
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value="all">All</option>
          </select>
          <span>entries</span>
        </div>
      </div>

      <div className="ul-table-wrapper">
        <table className="ul-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Wood Type</th>
              <th>KG</th>
              <th>CET</th>
              <th>Remark</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="text-center">
                  Loading...
                </td>
              </tr>
            ) : paginatedData.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center text-muted">
                  No wood types found
                </td>
              </tr>
            ) : (
              paginatedData.map((w, i) => (
                <tr key={w.id}>
                  <td>
                    {pageSize === "all"
                      ? i + 1
                      : (currentPage - 1) * effectivePageSize + i + 1}
                  </td>
                  <td>{w.wood_type}</td>
                  <td>{w.kg}</td>
                  <td>{w.cet}</td>
                  <td>{w.remark}</td>
                  <td className="ul-actions">
                    <Link
                      to={`/edit-wood-type/${w.id}`}
                      className="ul-btn edit"
                    >
                      <RiEdit2Line /> Edit
                    </Link>
                    <button
                      className="ul-btn delete"
                      onClick={() => handleDelete(w.id)}
                    >
                      <RiDeleteBin6Line /> Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {pageSize !== "all" && totalPages > 1 && (
        <div className="ul-pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            <RiArrowLeftSLine />
          </button>

          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              className={currentPage === i + 1 ? "active" : ""}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            <RiArrowRightSLine />
          </button>
        </div>
      )}
    </div>
  );
};

export default WoodTypeListLayer;
